<template>
  <div id="out-of-stock-section" v-for="(product, index) in productsOutOfStock" :key="`cart-item-${index}`"
       :index="index" class="bg-white border-b">
    <swipe-wrapper :product="product">
      <template #default="{ swipeLoader }">
        <cart-item :product="product" :source-data="sourceData" :swipe-loader="swipeLoader" :hide-price="false">
          <template #product-info>
            <div>
              <div class="text-xs text-grey-muted mb-1 font-niceone-medium opacity-80">{{
                  product?.manufacturer_name
                }}
              </div>
              <div class="van-multi-ellipsis--l2 text-xs text-grey-muted">{{ product?.name }}</div>
            </div>
          </template>
        </cart-item>
      </template>
    </swipe-wrapper>
  </div>
</template>

<script setup>
import SwipeWrapper from "@/components/cart/mobile/SwipeWrapper"
import CartItem from '@/components/cart/Item';
import {useCartStore} from '@/store/cart'

defineProps({
  sourceData: {
    type: Object,
    default: {}
  }
})

const cartStore = useCartStore()
const {productsOutOfStock} = storeToRefs(cartStore)
</script>